import { render, staticRenderFns } from "./ValuePropsItem.vue?vue&type=template&id=bfccc8dc&scoped=true"
import script from "./ValuePropsItem.vue?vue&type=script&lang=js"
export * from "./ValuePropsItem.vue?vue&type=script&lang=js"
import style0 from "./ValuePropsItem.vue?vue&type=style&index=0&id=bfccc8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfccc8dc",
  null
  
)

export default component.exports